import { getSendBirdToken } from 'services/pgConfig';
import { getItemFromLocalStorage } from 'utils/common';
import { accountManagerSortingOrder } from './constants';
import { ChatbotConfig, TAccountManagerList } from './types';

export const sortAccountManagerList = (list: TAccountManagerList = []) => {
  const orderOfManagerRole = role =>
    accountManagerSortingOrder[role] || accountManagerSortingOrder.default;

  list.sort(
    (manager1, manager2) =>
      orderOfManagerRole(manager1.managerRole) -
      orderOfManagerRole(manager2.managerRole),
  );

  return list;
};

export const sendBirdInitialisationScript = async (mid: number) => {
  const merchantId = mid || getItemFromLocalStorage('merchantId');
  if (!merchantId) return;
  const script = (
    w: any,
    d: Document,
    s: string,
    ...args: (string | ChatbotConfig)[]
  ) => {
    const div = d.createElement('div');
    div.id = 'aichatbot';
    d.body.appendChild(div);
    w.chatbotConfig = args;
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s) as HTMLScriptElement;
    j.defer = true;
    j.type = 'module';
    j.src = 'https://aichatbot.sendbird.com/index.js';
    f.parentNode.insertBefore(j, f);
  };

  const response: {
    token: string;
    expiresAt: string;
  } = await getSendBirdToken(merchantId);

  if (!response.token) return;

  script(
    window,
    document,
    'script',
    process.env.SEND_BIRD_APP_ID,
    process.env.SEND_BIRD_BOT_ID,
    {
      apiHost: 'https://api-cf-ap-5.sendbird.com',
      userId: String(merchantId),
      sessionToken: response.token,
      configureSession: () => ({
        onSessionTokenRequired: (resolve, reject) => {
          // Action to take when a session token is required
          getSendBirdToken(merchantId)
            .then(resolve)
            .catch(reject);
        },
        onSessionRefreshed: () => {
          // Action to take when session is refreshed
          console.log('Session refreshed');
        },
        onSessionError: err => {
          // Action to take when session encounters an error
          console.error('Session error', err);
        },
        onSessionClosed: () => {
          // Action to take when session is closed
          console.log('Session closed', response.token);
        },
      }),
    },
  );
};

export const cleanupChatbot = (w: Window, d: Document, s: string) => {
  try {
    const chatContainer = d.getElementById('aichatbot');
    if (chatContainer) {
      chatContainer.remove();
    }

    const scriptTags = d.getElementsByTagName(s);
    for (let i = 0; i < scriptTags.length; i++) {
      const scriptTag = scriptTags[i] as HTMLScriptElement;
      if (scriptTag.src === 'https://aichatbot.sendbird.com/index.js') {
        scriptTag.remove();
        break;
      }
    }

    if ('chatbotConfig' in w) {
      delete (w as any).chatbotConfig;
    }
  } catch (error) {
    console.error('Error during chatbot cleanup:', error);
  }
};
